import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import '@purple/semantic-ui-purple-theme/components/grid.css';

export default Grid;
